import script from "./DashboardLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardLayout.vue?vue&type=style&index=0&id=4c9f80e8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9f80e8"]])

export default __exports__